/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as AuthenticatedChatsIndexRouteImport } from './routes/_authenticated/chats/index'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedFleetIndexRouteImport } from './routes/_authenticated/fleet/index'
import { Route as AuthenticatedFleetNewRouteImport } from './routes/_authenticated/fleet/new'
import { Route as AuthenticatedHelpCenterIndexRouteImport } from './routes/_authenticated/help-center/index'
import { Route as AuthenticatedInsightsIndexRouteImport } from './routes/_authenticated/insights/index'
import { Route as AuthenticatedLoadsIndexRouteImport } from './routes/_authenticated/loads/index'
import { Route as AuthenticatedLoadsNewRouteImport } from './routes/_authenticated/loads/new'
import { Route as AuthenticatedMatchingIndexRouteImport } from './routes/_authenticated/matching/index'
import { Route as AuthenticatedRoutesIndexRouteImport } from './routes/_authenticated/routes/index'
import { Route as AuthenticatedRoutesNewRouteImport } from './routes/_authenticated/routes/new'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsAccountRouteImport } from './routes/_authenticated/settings/account'
import { Route as AuthenticatedSettingsAppearanceRouteImport } from './routes/_authenticated/settings/appearance'
import { Route as AuthenticatedSettingsBillingRouteImport } from './routes/_authenticated/settings/billing'
import { Route as AuthenticatedSettingsCompanyRouteImport } from './routes/_authenticated/settings/company'
import { Route as AuthenticatedSettingsDisplayRouteImport } from './routes/_authenticated/settings/display'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsSecurityRouteImport } from './routes/_authenticated/settings/security'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedUsersIndexRouteImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedFleetVehicle_idEditRouteImport } from './routes/_authenticated/fleet/$vehicle_id/edit'
import { Route as AuthenticatedLoadsLoad_idEditRouteImport } from './routes/_authenticated/loads/$load_id/edit'
import { Route as AuthenticatedLoadsLoad_idEditFormRouteImport } from './routes/_authenticated/loads/$load_id/edit-form'
import { Route as AuthenticatedMatchingLoad_idRoute_idRouteImport } from './routes/_authenticated/matching/$load_id/$route_id'
import { Route as AuthenticatedMatchingBrowseLoad_idRouteImport } from './routes/_authenticated/matching/browse.$load_id'
import { Route as AuthenticatedRoutesRoute_idIndexRouteImport } from './routes/_authenticated/routes/$route_id/index'
import { Route as AuthenticatedRoutesRoute_idEditRouteImport } from './routes/_authenticated/routes/$route_id/edit'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/(auth)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedChatsIndexRoute = AuthenticatedChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFleetIndexRoute = AuthenticatedFleetIndexRouteImport.update({
  id: '/fleet/',
  path: '/fleet/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFleetNewRoute = AuthenticatedFleetNewRouteImport.update({
  id: '/fleet/new',
  path: '/fleet/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedHelpCenterIndexRoute =
  AuthenticatedHelpCenterIndexRouteImport.update({
    id: '/help-center/',
    path: '/help-center/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedInsightsIndexRoute =
  AuthenticatedInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLoadsIndexRoute = AuthenticatedLoadsIndexRouteImport.update({
  id: '/loads/',
  path: '/loads/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedLoadsNewRoute = AuthenticatedLoadsNewRouteImport.update({
  id: '/loads/new',
  path: '/loads/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedMatchingIndexRoute =
  AuthenticatedMatchingIndexRouteImport.update({
    id: '/matching/',
    path: '/matching/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRoutesIndexRoute =
  AuthenticatedRoutesIndexRouteImport.update({
    id: '/routes/',
    path: '/routes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRoutesNewRoute = AuthenticatedRoutesNewRouteImport.update({
  id: '/routes/new',
  path: '/routes/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAccountRoute =
  AuthenticatedSettingsAccountRouteImport.update({
    id: '/account',
    path: '/account',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsAppearanceRoute =
  AuthenticatedSettingsAppearanceRouteImport.update({
    id: '/appearance',
    path: '/appearance',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsBillingRoute =
  AuthenticatedSettingsBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsCompanyRoute =
  AuthenticatedSettingsCompanyRouteImport.update({
    id: '/company',
    path: '/company',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsDisplayRoute =
  AuthenticatedSettingsDisplayRouteImport.update({
    id: '/display',
    path: '/display',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsSecurityRoute =
  AuthenticatedSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFleetVehicle_idEditRoute =
  AuthenticatedFleetVehicle_idEditRouteImport.update({
    id: '/fleet/$vehicle_id/edit',
    path: '/fleet/$vehicle_id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLoadsLoad_idEditRoute =
  AuthenticatedLoadsLoad_idEditRouteImport.update({
    id: '/loads/$load_id/edit',
    path: '/loads/$load_id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedLoadsLoad_idEditFormRoute =
  AuthenticatedLoadsLoad_idEditFormRouteImport.update({
    id: '/loads/$load_id/edit-form',
    path: '/loads/$load_id/edit-form',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMatchingLoad_idRoute_idRoute =
  AuthenticatedMatchingLoad_idRoute_idRouteImport.update({
    id: '/matching/$load_id/$route_id',
    path: '/matching/$load_id/$route_id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedMatchingBrowseLoad_idRoute =
  AuthenticatedMatchingBrowseLoad_idRouteImport.update({
    id: '/matching/browse/$load_id',
    path: '/matching/browse/$load_id',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRoutesRoute_idIndexRoute =
  AuthenticatedRoutesRoute_idIndexRouteImport.update({
    id: '/routes/$route_id/',
    path: '/routes/$route_id/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedRoutesRoute_idEditRoute =
  AuthenticatedRoutesRoute_idEditRouteImport.update({
    id: '/routes/$route_id/edit',
    path: '/routes/$route_id/edit',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/fleet/new': typeof AuthenticatedFleetNewRoute
  '/loads/new': typeof AuthenticatedLoadsNewRoute
  '/routes/new': typeof AuthenticatedRoutesNewRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/chats/': typeof AuthenticatedChatsIndexRoute
  '/fleet/': typeof AuthenticatedFleetIndexRoute
  '/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/insights/': typeof AuthenticatedInsightsIndexRoute
  '/loads/': typeof AuthenticatedLoadsIndexRoute
  '/matching/': typeof AuthenticatedMatchingIndexRoute
  '/routes/': typeof AuthenticatedRoutesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/fleet/$vehicle_id/edit': typeof AuthenticatedFleetVehicle_idEditRoute
  '/loads/$load_id/edit': typeof AuthenticatedLoadsLoad_idEditRoute
  '/loads/$load_id/edit-form': typeof AuthenticatedLoadsLoad_idEditFormRoute
  '/matching/$load_id/$route_id': typeof AuthenticatedMatchingLoad_idRoute_idRoute
  '/matching/browse/$load_id': typeof AuthenticatedMatchingBrowseLoad_idRoute
  '/routes/$route_id/edit': typeof AuthenticatedRoutesRoute_idEditRoute
  '/routes/$route_id/': typeof AuthenticatedRoutesRoute_idIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/': typeof AuthenticatedIndexRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/fleet/new': typeof AuthenticatedFleetNewRoute
  '/loads/new': typeof AuthenticatedLoadsNewRoute
  '/routes/new': typeof AuthenticatedRoutesNewRoute
  '/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/chats': typeof AuthenticatedChatsIndexRoute
  '/fleet': typeof AuthenticatedFleetIndexRoute
  '/help-center': typeof AuthenticatedHelpCenterIndexRoute
  '/insights': typeof AuthenticatedInsightsIndexRoute
  '/loads': typeof AuthenticatedLoadsIndexRoute
  '/matching': typeof AuthenticatedMatchingIndexRoute
  '/routes': typeof AuthenticatedRoutesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/fleet/$vehicle_id/edit': typeof AuthenticatedFleetVehicle_idEditRoute
  '/loads/$load_id/edit': typeof AuthenticatedLoadsLoad_idEditRoute
  '/loads/$load_id/edit-form': typeof AuthenticatedLoadsLoad_idEditFormRoute
  '/matching/$load_id/$route_id': typeof AuthenticatedMatchingLoad_idRoute_idRoute
  '/matching/browse/$load_id': typeof AuthenticatedMatchingBrowseLoad_idRoute
  '/routes/$route_id/edit': typeof AuthenticatedRoutesRoute_idEditRoute
  '/routes/$route_id': typeof AuthenticatedRoutesRoute_idIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/fleet/new': typeof AuthenticatedFleetNewRoute
  '/_authenticated/loads/new': typeof AuthenticatedLoadsNewRoute
  '/_authenticated/routes/new': typeof AuthenticatedRoutesNewRoute
  '/_authenticated/settings/account': typeof AuthenticatedSettingsAccountRoute
  '/_authenticated/settings/appearance': typeof AuthenticatedSettingsAppearanceRoute
  '/_authenticated/settings/billing': typeof AuthenticatedSettingsBillingRoute
  '/_authenticated/settings/company': typeof AuthenticatedSettingsCompanyRoute
  '/_authenticated/settings/display': typeof AuthenticatedSettingsDisplayRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/security': typeof AuthenticatedSettingsSecurityRoute
  '/_authenticated/chats/': typeof AuthenticatedChatsIndexRoute
  '/_authenticated/fleet/': typeof AuthenticatedFleetIndexRoute
  '/_authenticated/help-center/': typeof AuthenticatedHelpCenterIndexRoute
  '/_authenticated/insights/': typeof AuthenticatedInsightsIndexRoute
  '/_authenticated/loads/': typeof AuthenticatedLoadsIndexRoute
  '/_authenticated/matching/': typeof AuthenticatedMatchingIndexRoute
  '/_authenticated/routes/': typeof AuthenticatedRoutesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/fleet/$vehicle_id/edit': typeof AuthenticatedFleetVehicle_idEditRoute
  '/_authenticated/loads/$load_id/edit': typeof AuthenticatedLoadsLoad_idEditRoute
  '/_authenticated/loads/$load_id/edit-form': typeof AuthenticatedLoadsLoad_idEditFormRoute
  '/_authenticated/matching/$load_id/$route_id': typeof AuthenticatedMatchingLoad_idRoute_idRoute
  '/_authenticated/matching/browse/$load_id': typeof AuthenticatedMatchingBrowseLoad_idRoute
  '/_authenticated/routes/$route_id/edit': typeof AuthenticatedRoutesRoute_idEditRoute
  '/_authenticated/routes/$route_id/': typeof AuthenticatedRoutesRoute_idIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/errors/$error'
    | '/fleet/new'
    | '/loads/new'
    | '/routes/new'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/billing'
    | '/settings/company'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/security'
    | '/chats/'
    | '/fleet/'
    | '/help-center/'
    | '/insights/'
    | '/loads/'
    | '/matching/'
    | '/routes/'
    | '/settings/'
    | '/tasks/'
    | '/users/'
    | '/fleet/$vehicle_id/edit'
    | '/loads/$load_id/edit'
    | '/loads/$load_id/edit-form'
    | '/matching/$load_id/$route_id'
    | '/matching/browse/$load_id'
    | '/routes/$route_id/edit'
    | '/routes/$route_id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/'
    | '/errors/$error'
    | '/fleet/new'
    | '/loads/new'
    | '/routes/new'
    | '/settings/account'
    | '/settings/appearance'
    | '/settings/billing'
    | '/settings/company'
    | '/settings/display'
    | '/settings/notifications'
    | '/settings/security'
    | '/chats'
    | '/fleet'
    | '/help-center'
    | '/insights'
    | '/loads'
    | '/matching'
    | '/routes'
    | '/settings'
    | '/tasks'
    | '/users'
    | '/fleet/$vehicle_id/edit'
    | '/loads/$load_id/edit'
    | '/loads/$load_id/edit-form'
    | '/matching/$load_id/$route_id'
    | '/matching/browse/$load_id'
    | '/routes/$route_id/edit'
    | '/routes/$route_id'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/settings'
    | '/(auth)/forgot-password'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/'
    | '/_authenticated/errors/$error'
    | '/_authenticated/fleet/new'
    | '/_authenticated/loads/new'
    | '/_authenticated/routes/new'
    | '/_authenticated/settings/account'
    | '/_authenticated/settings/appearance'
    | '/_authenticated/settings/billing'
    | '/_authenticated/settings/company'
    | '/_authenticated/settings/display'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/security'
    | '/_authenticated/chats/'
    | '/_authenticated/fleet/'
    | '/_authenticated/help-center/'
    | '/_authenticated/insights/'
    | '/_authenticated/loads/'
    | '/_authenticated/matching/'
    | '/_authenticated/routes/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/_authenticated/users/'
    | '/_authenticated/fleet/$vehicle_id/edit'
    | '/_authenticated/loads/$load_id/edit'
    | '/_authenticated/loads/$load_id/edit-form'
    | '/_authenticated/matching/$load_id/$route_id'
    | '/_authenticated/matching/browse/$load_id'
    | '/_authenticated/routes/$route_id/edit'
    | '/_authenticated/routes/$route_id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/chats/': {
      id: '/_authenticated/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof AuthenticatedChatsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fleet/': {
      id: '/_authenticated/fleet/'
      path: '/fleet'
      fullPath: '/fleet/'
      preLoaderRoute: typeof AuthenticatedFleetIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fleet/new': {
      id: '/_authenticated/fleet/new'
      path: '/fleet/new'
      fullPath: '/fleet/new'
      preLoaderRoute: typeof AuthenticatedFleetNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/help-center/': {
      id: '/_authenticated/help-center/'
      path: '/help-center'
      fullPath: '/help-center/'
      preLoaderRoute: typeof AuthenticatedHelpCenterIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/insights/': {
      id: '/_authenticated/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthenticatedInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/loads/': {
      id: '/_authenticated/loads/'
      path: '/loads'
      fullPath: '/loads/'
      preLoaderRoute: typeof AuthenticatedLoadsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/loads/new': {
      id: '/_authenticated/loads/new'
      path: '/loads/new'
      fullPath: '/loads/new'
      preLoaderRoute: typeof AuthenticatedLoadsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/matching/': {
      id: '/_authenticated/matching/'
      path: '/matching'
      fullPath: '/matching/'
      preLoaderRoute: typeof AuthenticatedMatchingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/routes/': {
      id: '/_authenticated/routes/'
      path: '/routes'
      fullPath: '/routes/'
      preLoaderRoute: typeof AuthenticatedRoutesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/routes/new': {
      id: '/_authenticated/routes/new'
      path: '/routes/new'
      fullPath: '/routes/new'
      preLoaderRoute: typeof AuthenticatedRoutesNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/account': {
      id: '/_authenticated/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AuthenticatedSettingsAccountRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/appearance': {
      id: '/_authenticated/settings/appearance'
      path: '/appearance'
      fullPath: '/settings/appearance'
      preLoaderRoute: typeof AuthenticatedSettingsAppearanceRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/billing': {
      id: '/_authenticated/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthenticatedSettingsBillingRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/company': {
      id: '/_authenticated/settings/company'
      path: '/company'
      fullPath: '/settings/company'
      preLoaderRoute: typeof AuthenticatedSettingsCompanyRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/display': {
      id: '/_authenticated/settings/display'
      path: '/display'
      fullPath: '/settings/display'
      preLoaderRoute: typeof AuthenticatedSettingsDisplayRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/security': {
      id: '/_authenticated/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AuthenticatedSettingsSecurityRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/fleet/$vehicle_id/edit': {
      id: '/_authenticated/fleet/$vehicle_id/edit'
      path: '/fleet/$vehicle_id/edit'
      fullPath: '/fleet/$vehicle_id/edit'
      preLoaderRoute: typeof AuthenticatedFleetVehicle_idEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/loads/$load_id/edit': {
      id: '/_authenticated/loads/$load_id/edit'
      path: '/loads/$load_id/edit'
      fullPath: '/loads/$load_id/edit'
      preLoaderRoute: typeof AuthenticatedLoadsLoad_idEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/loads/$load_id/edit-form': {
      id: '/_authenticated/loads/$load_id/edit-form'
      path: '/loads/$load_id/edit-form'
      fullPath: '/loads/$load_id/edit-form'
      preLoaderRoute: typeof AuthenticatedLoadsLoad_idEditFormRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/matching/$load_id/$route_id': {
      id: '/_authenticated/matching/$load_id/$route_id'
      path: '/matching/$load_id/$route_id'
      fullPath: '/matching/$load_id/$route_id'
      preLoaderRoute: typeof AuthenticatedMatchingLoad_idRoute_idRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/matching/browse/$load_id': {
      id: '/_authenticated/matching/browse/$load_id'
      path: '/matching/browse/$load_id'
      fullPath: '/matching/browse/$load_id'
      preLoaderRoute: typeof AuthenticatedMatchingBrowseLoad_idRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/routes/$route_id/': {
      id: '/_authenticated/routes/$route_id/'
      path: '/routes/$route_id'
      fullPath: '/routes/$route_id/'
      preLoaderRoute: typeof AuthenticatedRoutesRoute_idIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/routes/$route_id/edit': {
      id: '/_authenticated/routes/$route_id/edit'
      path: '/routes/$route_id/edit'
      fullPath: '/routes/$route_id/edit'
      preLoaderRoute: typeof AuthenticatedRoutesRoute_idEditRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsAccountRoute: typeof AuthenticatedSettingsAccountRoute
  AuthenticatedSettingsAppearanceRoute: typeof AuthenticatedSettingsAppearanceRoute
  AuthenticatedSettingsBillingRoute: typeof AuthenticatedSettingsBillingRoute
  AuthenticatedSettingsCompanyRoute: typeof AuthenticatedSettingsCompanyRoute
  AuthenticatedSettingsDisplayRoute: typeof AuthenticatedSettingsDisplayRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsSecurityRoute: typeof AuthenticatedSettingsSecurityRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsAccountRoute: AuthenticatedSettingsAccountRoute,
    AuthenticatedSettingsAppearanceRoute: AuthenticatedSettingsAppearanceRoute,
    AuthenticatedSettingsBillingRoute: AuthenticatedSettingsBillingRoute,
    AuthenticatedSettingsCompanyRoute: AuthenticatedSettingsCompanyRoute,
    AuthenticatedSettingsDisplayRoute: AuthenticatedSettingsDisplayRoute,
    AuthenticatedSettingsNotificationsRoute:
      AuthenticatedSettingsNotificationsRoute,
    AuthenticatedSettingsSecurityRoute: AuthenticatedSettingsSecurityRoute,
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedFleetNewRoute: typeof AuthenticatedFleetNewRoute
  AuthenticatedLoadsNewRoute: typeof AuthenticatedLoadsNewRoute
  AuthenticatedRoutesNewRoute: typeof AuthenticatedRoutesNewRoute
  AuthenticatedChatsIndexRoute: typeof AuthenticatedChatsIndexRoute
  AuthenticatedFleetIndexRoute: typeof AuthenticatedFleetIndexRoute
  AuthenticatedHelpCenterIndexRoute: typeof AuthenticatedHelpCenterIndexRoute
  AuthenticatedInsightsIndexRoute: typeof AuthenticatedInsightsIndexRoute
  AuthenticatedLoadsIndexRoute: typeof AuthenticatedLoadsIndexRoute
  AuthenticatedMatchingIndexRoute: typeof AuthenticatedMatchingIndexRoute
  AuthenticatedRoutesIndexRoute: typeof AuthenticatedRoutesIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedFleetVehicle_idEditRoute: typeof AuthenticatedFleetVehicle_idEditRoute
  AuthenticatedLoadsLoad_idEditRoute: typeof AuthenticatedLoadsLoad_idEditRoute
  AuthenticatedLoadsLoad_idEditFormRoute: typeof AuthenticatedLoadsLoad_idEditFormRoute
  AuthenticatedMatchingLoad_idRoute_idRoute: typeof AuthenticatedMatchingLoad_idRoute_idRoute
  AuthenticatedMatchingBrowseLoad_idRoute: typeof AuthenticatedMatchingBrowseLoad_idRoute
  AuthenticatedRoutesRoute_idEditRoute: typeof AuthenticatedRoutesRoute_idEditRoute
  AuthenticatedRoutesRoute_idIndexRoute: typeof AuthenticatedRoutesRoute_idIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedFleetNewRoute: AuthenticatedFleetNewRoute,
  AuthenticatedLoadsNewRoute: AuthenticatedLoadsNewRoute,
  AuthenticatedRoutesNewRoute: AuthenticatedRoutesNewRoute,
  AuthenticatedChatsIndexRoute: AuthenticatedChatsIndexRoute,
  AuthenticatedFleetIndexRoute: AuthenticatedFleetIndexRoute,
  AuthenticatedHelpCenterIndexRoute: AuthenticatedHelpCenterIndexRoute,
  AuthenticatedInsightsIndexRoute: AuthenticatedInsightsIndexRoute,
  AuthenticatedLoadsIndexRoute: AuthenticatedLoadsIndexRoute,
  AuthenticatedMatchingIndexRoute: AuthenticatedMatchingIndexRoute,
  AuthenticatedRoutesIndexRoute: AuthenticatedRoutesIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
  AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
  AuthenticatedFleetVehicle_idEditRoute: AuthenticatedFleetVehicle_idEditRoute,
  AuthenticatedLoadsLoad_idEditRoute: AuthenticatedLoadsLoad_idEditRoute,
  AuthenticatedLoadsLoad_idEditFormRoute:
    AuthenticatedLoadsLoad_idEditFormRoute,
  AuthenticatedMatchingLoad_idRoute_idRoute:
    AuthenticatedMatchingLoad_idRoute_idRoute,
  AuthenticatedMatchingBrowseLoad_idRoute:
    AuthenticatedMatchingBrowseLoad_idRoute,
  AuthenticatedRoutesRoute_idEditRoute: AuthenticatedRoutesRoute_idEditRoute,
  AuthenticatedRoutesRoute_idIndexRoute: AuthenticatedRoutesRoute_idIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
